import type { Deal } from "../types";
import { getDealPipeline, dealPipelines, type DealPipeline } from "./pipelines";

export function isProjectClosed(
  project: Pick<Deal, "pipeline" | "stage">,
  pipelines: DealPipeline[] = dealPipelines,
) {
  const pipeline = getDealPipeline(project.pipeline, pipelines);
  return [...pipeline.wonStages, ...pipeline.lostStages].includes(
    project.stage,
  );
}

export function isProjectOverdue(
  project: Pick<
    Deal,
    "pipeline" | "stage" | "archived_at" | "expected_closing_date"
  >,
  today = new Date(),
  pipelines: DealPipeline[] = dealPipelines,
) {
  if (
    project.archived_at ||
    isProjectClosed(project, pipelines) ||
    !project.expected_closing_date
  )
    return false;
  const value = project.expected_closing_date.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split("-").map(Number);
  const due = new Date(year, month - 1, day);
  if (
    due.getFullYear() !== year ||
    due.getMonth() !== month - 1 ||
    due.getDate() !== day
  )
    return false;
  const start = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );
  return due < start;
}

export function formatProjectDate(value?: string | null) {
  if (!value) return "Не задан";
  const date = new Date(value.slice(0, 10) + "T00:00:00");
  return Number.isNaN(date.getTime())
    ? "Не задан"
    : date.toLocaleDateString("ru-RU");
}
